export const USER_FRAGMENT = `
    fragment UserFragment on User {
        objectId
        email
        displayName
        avatarUrl
        userType
        type
    }
`;